import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';

export const Route = createFileRoute('/departments')({
  component: () => <RouteGuard route="/departments" />,
});
